<template>
	<div class="list">
		<ul class="list">
			<li v-for="item in arr" :key="item.id">
				<router-link :to="{path:'/detail',query:{type:item.type,id:item.id}}">
					<div class="li_div">
						<div class="div_left">
							<img :src="item.title_pic" alt="">
						</div>
						<div class="div_right">
							<h2>{{item.title}}</h2>
							<p>{{item.brief}}</p>
							<div>
								<span>{{item.author}}</span>
								<span>{{item.create_date|dateTrans}}</span>
								<span>{{item.reads}}次浏览</span>
							</div>
						</div>
					</div>
				</router-link>
			</li>
		</ul>
	</div>
</template>

<script>
	export default{
		props:{
			arr:{
				required:false,
				type:Array
			}
		}
	}
</script>

<style scoped>
	.list li {
		margin-bottom: 1px;
	}

	.list li a {
		display: block;
		background-color: #FFFFFF;
		padding: 10px 20px;
		box-sizing: border-box;
	}

	.list li a:hover {
		background-color: #fafff8;
	}

	.list li a:hover .div_right h2 {
		color: #4eae30;
	}

	.li_div {
		overflow: hidden;
	}

	.div_left {
		float: left;
		width: 25%;
		height: 150px;
	}

	.div_left img {
		width: 100%;
		height: 100%;
		border-radius: 5px;
	}

	.div_right {
		float: left;
		width: 75%;
		height: 150px;
		padding: 10px 10px 10px 20px;
		box-sizing: border-box;
	}

	.div_right h2 {
		overflow: hidden;
		height: 25px;
		font-weight: 700;
		font-size: 16px;
	}

	.div_right p {
		color: #888;
		line-height: 24px;
		font-size: 14px;
		margin: 10px 0;
	}

	.div_right div {
		color: #999;
		font-size: 12px;
	}

	.div_right div span {
		margin-right: 20px;
		padding-left: 17px;
	}
	.div_right div span:nth-child(1){
		background: url(../../assets/images/author.png) no-repeat;
		background-size: 14px 14px;
	}
	.div_right div span:nth-child(2){
		background: url(../../assets/images/date.png) no-repeat;
		background-size: 12px 12px;
		background-position: 1px 2px;
	}
	.div_right div span:nth-child(3){
		background: url(../../assets/images/read.png) no-repeat;
		background-size: 14px 14px;
		background-position: 1px 2px;
	}
</style>
